import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dtm: false,
    lang: '',
    country: '',
    txt: {},
    lightBox: {
      lightboxVisible: false
    },
    range: {
      passengers: 1,
      speed: undefined,
      outside_temperature: undefined,
      ac: true,
      eco: true,
      performance: false,
      e4force: false,
      wheel: 19,
      model: "63KWH",
      battery_ranges: [],
      backgroundImg: {
        passengersImage: ['solo.png', 'couple.png', 'famille.png']
      }
      // batteries in an object so we can have unlimited batteries & battery name
      // the order is based on the order in the object we received from the JSON lang file
    }
  },
  mutations: {
    SET_DTM(state, dtm) {
      state.dtm = dtm;
    },
    SET_COUNTRY(state, country) {
      state.country = country;
    },
    SET_LANG(state, lang) {
      state.lang = lang;
    },
    SET_TXT(state, json) {
      state.txt = json;
    },
    SET_AUTONOMY(state, json) {
      state.autonomy = json;
    },
    TOGGLE_POPIN(state) {
      state.lightBox.lightboxVisible = !state.lightBox.lightboxVisible;
    },
    SET_SPEED(state, speed) {
      state.range.speed = speed;
    },
    SET_PASSENGERS(state, passengers) {
      state.range.passengers = passengers;
    },
    SET_TEMPERATURE(state, temperature) {
      state.range.outside_temperature = temperature;
    },
    SET_AC(state, bool) {
      state.range.ac = bool;
    },
    SET_ECO(state, bool) {
      state.range.eco = bool;
    },

    SET_WHEEL(state, wheel) {
      state.range.wheel = wheel;
    },
    SET_MODEL(state, model) {
      state.range.model = model;
    },
    SET_E4FORCE(state, bool) {
      state.range.e4force = bool;
    },
    SET_PERFORMANCE(state, bool) {
      state.range.performance = bool;
    },
    SET_BATTERY_RANGE(state, array) {
      state.range.battery_ranges = array;
    },

    // remove useless speed scale
    REMOVE_SPEED_SCALE(state, index) {
      state.txt.common.speed.scale.splice(index, 1);
    }
  },
  actions: {
    togglePopin(vuexContext) {
      vuexContext.commit('TOGGLE_POPIN');
    },
    setBatteriesRange(vuexContext, { array }) {
      vuexContext.commit('SET_BATTERY_RANGE', { array });
    }
  }
});
